module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/dog-field-582.3e86f8320989d50c.png"+" 582w",
        images: [{path: "https://static.sniffspot.com/packs/img/dog-field-582.3e86f8320989d50c.png",width: 582,height: 400}],
        src: "https://static.sniffspot.com/packs/img/dog-field-582.3e86f8320989d50c.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/dog-field-582.3e86f8320989d50c.png"},
        
        width: 582,
        height: 400
      }